import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Creators
export const fetchCreators = (params = {}) =>
  client.get("/creators", { params }).then((r) => r.data);
export const fetchAllCreators = () =>
  client
    .get("/creators", { params: { page: 1, page_size: 1000 } })
    .then((r) => r.data.items || []);
export const fetchCreator = (id) => client.get(`/creators/${id}`).then((r) => r.data);
export const updateCreator = (id, body) =>
  client.patch(`/creators/${id}`, body).then((r) => r.data);
export const fetchCreatorFilterMeta = () =>
  client.get("/creators/meta/filters").then((r) => r.data);

const triggerBlobDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const exportCreators = async (format, params = {}) => {
  const path = format === "pdf" ? "/creators/export.pdf" : "/creators/export.csv";
  const res = await client.get(path, {
    params,
    responseType: "blob",
    paramsSerializer: (p) => {
      const sp = new URLSearchParams();
      Object.entries(p || {}).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "") return;
        if (Array.isArray(v)) v.forEach((item) => sp.append(k, item));
        else sp.append(k, v);
      });
      return sp.toString();
    },
  });
  const filename = format === "pdf" ? "bagfluence-creators.pdf" : "bagfluence-creators.csv";
  triggerBlobDownload(res.data, filename);
  return { ok: true };
};

export const bulkImportCreators = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client
    .post("/creators/bulk-import", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// Audit log
export const fetchAuditLog = (params = {}) =>
  client.get("/audit-log", { params }).then((r) => r.data);

// Brands
export const fetchBrands = () => client.get("/brands").then((r) => r.data);

// Campaigns
export const fetchCampaigns = () => client.get("/campaigns").then((r) => r.data);
export const fetchCampaign = (id) => client.get(`/campaigns/${id}`).then((r) => r.data);
export const updateCampaign = (id, body) =>
  client.patch(`/campaigns/${id}`, body).then((r) => r.data);

// Leads
export const fetchLeads = () => client.get("/leads").then((r) => r.data);
export const updateLead = (id, body) => client.patch(`/leads/${id}`, body).then((r) => r.data);
export const createLead = (body) => client.post("/leads", body).then((r) => r.data);

// Tasks
export const fetchTasks = () => client.get("/tasks").then((r) => r.data);
export const updateTask = (id, body) => client.patch(`/tasks/${id}`, body).then((r) => r.data);

// Analytics
export const fetchAnalytics = () => client.get("/analytics/overview").then((r) => r.data);
export const analyticsCsvUrl = `${API}/analytics/export.csv`;

// Creator Applications
export const fetchApplications = () =>
  client.get("/creator-applications").then((r) => r.data);
export const updateApplication = (id, body) =>
  client.patch(`/creator-applications/${id}`, body).then((r) => r.data);
export const deleteApplication = (id) =>
  client.delete(`/creator-applications/${id}`).then((r) => r.data);

// Generic creators / brands / campaigns / leads / tasks POST
export const createCreator = (body) => client.post("/creators", body).then((r) => r.data);
export const createBrand = (body) => client.post("/brands", body).then((r) => r.data);
export const createCampaign = (body) => client.post("/campaigns", body).then((r) => r.data);
export const createTask = (body) => client.post("/tasks", body).then((r) => r.data);

// Meta
export const fetchStages = () => client.get("/meta/stages").then((r) => r.data);

export const API_BASE = API;
export default client;
